/**
 * GET 회원 정보
 */
export const API_CONSULTATION_GET_APPLICANT = '/member/v2/me'

/**
 * PUT 회원 정보 업데이트
 */
export const API_CONSULTATION_UPDATE_MEMBER = (memberId: number) => `/member/${memberId}`

/**
 * POST 상담 신청
 */
export const API_CONSULTATION_SERVICE_OFFER = (serviceOfferId: number) => `/consultation/event/${serviceOfferId}`

/**
 * POST 병원 상담 신청
 */
export const API_CONSULTATION_HOSPITAL = (hospitalId: number) => `/consultation/hospital/${hospitalId}`

/**
 * POST 병원 채팅 상담 신청
 */
export const API_CONSULTATION_APPLY_CHAT = (hospitalId: number) =>
  `/consultation/v2/hospitals/${hospitalId}/chat-consultation`

/**
 * POST 의사 상담 신청
 */
export const API_CONSULTATION_DOCTOR = (doctorId: number) => `/consultation/doctor/${doctorId}`

/**
 * POST 인증 코드 요청
 */
export const API_CONSULTATION_REQUEST_AUTH_CODE = (memberId: number) => `/member/${memberId}/auth-phone`

/**
 * POST 인증 코드 요청 (비회원)
 */
export const API_CONSULTATION_REQUEST_AUTH_CODE_BYPASS = '/account/user/phone/send-verification-code'

/**
 * POST 번호 이전
 */
export const API_CONSULTATION_TRANSFER_PHONE = '/member/v2/commands/transfer-phone'
